<template>
  <w-icon-wrapper
    :width='24'
    :height='17.455'
    icon-name='work-nav-invoice-icon'
    view-box='0 0 24 17.455'
  >
    <path
      id="_05_Abrechnungen_Icon"
      data-name="05_Abrechnungen_Icon"
      d="M54.182-790.182a3.156,3.156,0,0,1-2.318-.955,3.156,3.156,0,0,1-.955-2.318,3.156,3.156,0,0,1,.955-2.318,3.156,3.156,0,0,1,2.318-.955,3.156,3.156,0,0,1,2.318.955,3.156,3.156,0,0,1,.955,2.318,3.156,3.156,0,0,1-.955,2.318A3.156,3.156,0,0,1,54.182-790.182Zm-7.636,3.273A2.1,2.1,0,0,1,45-787.55a2.1,2.1,0,0,1-.641-1.541v-8.727A2.1,2.1,0,0,1,45-799.359,2.1,2.1,0,0,1,46.545-800H61.818a2.1,2.1,0,0,1,1.541.641A2.1,2.1,0,0,1,64-797.818v8.727a2.1,2.1,0,0,1-.641,1.541,2.1,2.1,0,0,1-1.541.641Zm2.182-2.182H59.636a2.1,2.1,0,0,1,.641-1.541,2.1,2.1,0,0,1,1.541-.641v-4.364a2.1,2.1,0,0,1-1.541-.641,2.1,2.1,0,0,1-.641-1.541H48.727a2.1,2.1,0,0,1-.641,1.541,2.1,2.1,0,0,1-1.541.641v4.364a2.1,2.1,0,0,1,1.541.641A2.1,2.1,0,0,1,48.727-789.091Zm12,6.545H42.182a2.1,2.1,0,0,1-1.541-.641A2.1,2.1,0,0,1,40-784.727v-12h2.182v12H60.727Zm-14.182-6.545v0Z"
      transform="translate(-40 800)"
      fill="currentColor"
    />
  </w-icon-wrapper>
</template>

<script>
export default { name: 'WorkIconNavInvoice' };
</script>

